export function updateTemplateText(/* callback */) {
    let fragments = [];
    if (true) {
      fragments.push({
        target: 'password-protect-btn',
        config: {
          attrs: {
            text: 'password-protect:buttons.title',
          },
        },
      });
      fragments.push({
        target: 'remove-protect-btn',
        config: {
          attrs: {
            text: 'password-protect:buttons.removeTitle',
          },
        },
      });

    }
    fragments.push(
      {
        target: 'redaction-apply',
        config: {
          attrs: {
            text: 'phantom_online:toolbar.protect.apply',
          },
        },
      },
      {
        target: 'redaction-search',
        config: {
          attrs: {
            text: 'phantom_online:toolbar.protect.redact_search',
          },
        },
      },
      {
        target: 'create-square',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.square',
          },
        },
      },{
        target: 'create-polyline',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.polyline',
          },
        },
      },{
        target: 'create-polygon',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.polygon',
          },
        },
      },{
        target: 'create-cloud',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.cloud',
          },
        },
      },{
        target: 'create-arrow',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.arrow',
          },
        },
      },{
        target: 'create-circle',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.oval',
          },
        },
      },{
        target: 'create-line',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'toolbar.buttons.line',
          },
        },
      },{
        target: 'create-shape-dropdown',
        config: {
          attrs: {
            '@tooltip': '',
            'tooltip-title': 'phantom_online:toolbar.buttons.drawingTools',
          },
        },
      }
      // {
      //   target: 'add-pathObject-line,add-pathObject-square,add-pathObject-circle,add-pathObject-roundRect ',
      //   config: {
      //     attrs: {
      //       'tooltip-placement':"right"
      //     },
      //   },
      // }
    );
  
  
    const viewerTemplate = {
        fragments:fragments,
    };
    return viewerTemplate;
  }